<script>
    import { onMount, beforeUpdate, afterUpdate } from 'svelte';
    import { db } from './stores.js'
    export let display;
    let status='';
    let users=[];
    let userGroups=[];
    let selectedUser;
    let groupToAdd;
    let groupToAddToUser;
    let isAdmin = false;
    let isAdminSelectOption

    onMount ( async() => {
        console.log('onMount Users');
        $db.collection("users")
        .onSnapshot(function(querySnapshot) {
            console.log('querySnapshot: ', querySnapshot);
            users = [];
            querySnapshot.forEach(function(doc) {
                // doc.data() is never undefined for query doc snapshots
                users = [...users, {email:doc.id,...doc.data()}];
                console.log(doc.id, " => ", doc.data());
            });
        })
    });

    async function handleSubmit(event){
        status = "";
        console.log('email: ', event.target.email.value);
        console.log('isAdmin: ', isAdmin);
        isAdmin = (isAdminSelectOption === 'true');
        console.log('groups: ', userGroups);
        $db.collection('users').doc(event.target.email.value.toLowerCase()).set({
            isAdmin: isAdmin,
            groups: userGroups
        }, { merge: true})
        .then(function() {
            console.log("Document successfully written!");
            userGroups = [];
            event.target.email.value = '';
            status = "User saved successfully!"
        })
        .catch(error => {
            console.error("Got an error saving user: ",error);
            status = error;
        });
        $db.collection('allowed').doc('users').update({
            email: firebase.firestore.FieldValue.arrayUnion(event.target.email.value.toLowerCase())
        });
    };
    

    function addGroup(){
        userGroups = [...userGroups, groupToAdd];
        groupToAdd = '';
    }

    function addGroupToUser(){
        // userGroups = [...userGroups, groupToAdd];
        console.log('addGroupToUser selected user: ', selectedUser);
        console.log('groupToAddToUser: ', groupToAddToUser);
        $db.collection('users').doc(selectedUser.email).update({
            groups: [...selectedUser.groups, groupToAddToUser]
        })
        .then(function() {
            console.log("Document successfully written!");
            // userGroups = [];
            selectedUser.groups = [...selectedUser.groups, groupToAddToUser];
            groupToAddToUser = '';
        });

    }



</script>

{#if display === 'view'}
    <div id="users-container">
        <section id="users-list">
            <h1>View Users</h1>
            {#each users as user}
                <div>
                    {user.email}
                    <button on:click={() => selectedUser = user}>select</button>
                </div>
            {:else}
                <p>loading...</p>
            {/each}
        </section>
        <section id="user-details">
            {#if selectedUser}
                <div>id: {selectedUser.email}</div>
                isAdmin: <input value={selectedUser.isAdmin}/>
                <div>Groups</div>
                {#each selectedUser.groups as group}
                    <div>
                        <input value={group}/>
                    </div>
                {/each}
                <input type="number" id="group-to-add-to-user" bind:value={groupToAddToUser}/>
                <button type="button" on:click={addGroupToUser}>add group</button>    
            {:else}
                <p>Select a User</p>
            {/if}                
        </section>
    </div>
{:else if display === 'add'}
    <div id="add-form">
        <h1>Add a user</h1>
        <form id="add-group" on:submit|preventDefault={handleSubmit}>
            <label for="email">Enter email</label>
            <input type="email" id="email" required/>
            <label for="isAdmin">an Admin</label>
            <select bind:value={isAdminSelectOption}>
                <option value="false">
                    false
                </option>
                <option value="true">
                    true
                </option>
            </select>
            <div>Enter groups</div>
            {#each userGroups as group}
                <div>{group}</div>
            {:else}
                Add a group
            {/each}    
            <input type="number" id="group-to-add" bind:value={groupToAdd}/>
            <button type="button" on:click={addGroup}>add group</button>
            <br/><button type="submit">submit</button>
        </form>
        <div id="status">{status}</div>

    </div>
{/if}

<style>
    button {
        display: inline-block;
    }
    #users-container {
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: 100%;
    }

</style>

